import { useState } from 'react';
import { Form } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import sha256 from 'sha256';
import useValidator from '../../hooks/useValidator';
import { encodeBase64, encryptDecrypt } from '../../modules/helpers/validations';
import ModalNewPasswordSuccess from '../../modules/homeout/principal/components/modal/ModalNewPasswordSuccess';
import { changePassword } from '../../services/serviceVivetuseguro';
import { ModalClasico } from '../../modules/homeout/principal/components/modal/ModalClasico';

const SidebarPasswordNewPass = ({errorData,showModal, setShowModal , mensaje, recaptchaRef, setMensaje, setSpinner, setErrorData, formCode, setCount, urlApi, codRecaptcha, handleClose, setShowModalSuccess}) => {

    const [typeField, setTypeField] = useState(false);
    const [typeInput, setTypeInput] = useState('password');
    const [typeFieldConf, setTypeFieldConf] = useState(false);
    const [typeInputConf, setTypeInputConf] = useState('password');
    const [alerta, setAlerta] = useState(false)
    const [igual, setIgual] = useState(false)
    const [modalShow, setModalShow] = useState(false)


    const [formPass, setFormPass] = useState({
        id: "",
        code: "",
        password: "",
        passwordconfirm: "",
        tokenCaptcha: ""
    })

    const handleTypeField = (type)=> {
        setTypeField(type);
        setTypeInput((type) ? 'text' : 'password');
    }
    const handleTypeFieldConf = (type)=> {
        setTypeFieldConf(type);
        setTypeInputConf((type) ? 'text' : 'password');
    }


    const { formValidador, error } = useValidator(formPass.password)

    const handleChangePass = (e) => {
        setFormPass({
            ...formPass,
            [e.target.name]: e.target.value,
        })
    }

    const handleSubmitNuevaContrasena = async (e) => {
        // if (!showModal) {
        //     setModalShow(true)
        //     return                    
        // }
        // alert(error)

        setAlerta(false)
        setErrorData(false)
        setIgual(false)
        e.preventDefault();

        if (formPass.password===''&& formPass.passwordconfirm==='') {
            setAlerta(true)
            return setMensaje('Para continuar debes completar todos los campos.')
           
        }

        if(formPass.password!=formPass.passwordconfirm){
            setIgual(true)
            return
        }

        if (error) {
            setMensaje('La contraseña no cumple con los caracteres requeridos!')
            setAlerta(true)
            return
        }

        if ((formPass.password === formPass.passwordconfirm) && !error) {

            const token = await recaptchaRef.current.executeAsync();
            recaptchaRef.current.reset()
            if (!token) {
                setMensaje('Captcha inválido, actualizar web')
                return
            }

            setSpinner(true)
       

            try {
                let objUsuario = {
                    id: formCode.id,
                    code: formCode.code,
                    password: encodeBase64(encryptDecrypt(sha256(formPass.passwordconfirm),
                        token.substring(token.length - 10, token.length)
                    )),
                    tokenCaptcha: token
                }


                changePassword(objUsuario, urlApi).then(res => {
                    setSpinner(false)
                    if (res.codigo === 0) {
                        setMensaje("")
                        setErrorData(false)
                        handleClose()
                        setShowModalSuccess(true)

                    } else {
                        setMensaje(res.mensaje)
                        setAlerta(true)
                    }
                })
            } catch (err) {
                setMensaje(err)
                setErrorData(true)
                setSpinner(false)
            }
        } else {
           
            setErrorData(true)
            setMensaje("Las contraseñas deben ser iguales")
        }
    }

    const handleSuccessModal = () => {
        setModalShow(false)
        setShowModalSuccess(true)
        
    }

    return (
        <>
            <div className="body__login">
                
                <h2>Crea tu nueva contraseñad</h2>
                <p>Ingresa tu nueva contraseña para que puedas acceder a tus beneficios.</p>
              
                {
                    alerta&& <div className="alert text-center bg-rojo w-100 mb-0 mt-5 text-white fs-4" role="alert" > 
                        {mensaje}
                    </div>
                }
                <Form autoComplete="off" onSubmit={(e) => { e.preventDefault()}} className="form__modal" >
                    <div className="row justify-content-center">
                        <div className='col-12 login__pass'>
                            <input
                                maxLength={16}
                                type={typeInput}
                                className='form-control border-input '
                                id='password'
                                name='password'
                                placeholder='Contraseña'
                                autoComplete="off"
                                value={formPass.password}
                                onChange={handleChangePass}
                            />
                            {
                                typeField
                                ? <i onClick={() => handleTypeField(!typeField)} className="fa-solid fa-eye pass__icon"></i>
                                : <i onClick={() => handleTypeField(!typeField)} className="fa-solid fa-eye-slash pass__icon"></i>
                            }
                        </div>
                        <div className='col-12 login__pass'>
                            <input
                                maxLength={16}
                                type={typeInputConf}
                                className={`form-control border-input ${igual==true?'border-danger':null}`}
                                id='passwordconfirm'
                                name='passwordconfirm'
                                placeholder='Confirma tu contraseña'
                                autoComplete="off"
                                value={formPass.passwordconfirm}
                                onChange={handleChangePass}
                            />
                            {
                                typeFieldConf
                                ? <i onClick={() => handleTypeFieldConf(!typeFieldConf)} className="fa-solid fa-eye pass__icon"></i>
                                : <i onClick={() => handleTypeFieldConf(!typeFieldConf)} className="fa-solid fa-eye-slash pass__icon"></i>
                            }
                        </div>
                            {igual&&<p className='text-danger ms-4 '>Las contraseñas deben ser iguales</p>}
                        <div className='ps-4'>
                            {formValidador()}                            
                        </div>

                        <div className='col-12 mt-5 text-center'>
                            <button className="btn__azul" onClick={handleSubmitNuevaContrasena}>CREAR CONTRASEÑA</button>
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                size="invisible"
                                sitekey={codRecaptcha}
                            />
                        </div>
                    </div>
                </Form>           
            </div>
        </>
    )
}

export default SidebarPasswordNewPass